import { GenericSlider } from '@components/common/carousel/generic-slider';
import { getObjectValue } from '@services/object-extensions';
import { useState } from 'react';
import { ButtonGroup } from '../button-group/button-group';
import { Card } from '../card/card';

const LayoutTasti = ({ translations = {}, buttons = [], darkTheme = false, categoryId = '' }) => {
  const [visibleSlideNumber, setVisibleSlideNumber] = useState(0);
  const mappedSlides = getObjectValue(translations, 'card', [])?.map((element) => (
    <Card translations={element} />
  ));

  return (
    <div
      className="snf-lx-components-servizi-soluzioni-layout-tasti-layout-tasti"
      style={{ display: 'contents' }}
    >
      <>
        <div className="row sticky ">
          <div className="col-12 p-0">
            <ButtonGroup buttons={buttons} darkTheme={darkTheme} categoryId={categoryId} />
          </div>
          <div className="col-12 p-0">
            <GenericSlider
              autoPlay
              currentSlideIndex={visibleSlideNumber}
              slides={mappedSlides}
              onSlideChange={setVisibleSlideNumber}
              cyclic
            />
          </div>
        </div>
      </>
    </div>
  );
};

LayoutTasti.displayName = 'Layout Tasti ';
export { LayoutTasti };
